export default __webpack_public_path__ + "static/media/cvod-16.96e1770e.svg";